/**
 * @generated SignedSource<<df540a39247eb42208edca1f0adb858e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamCard_artist$data = {
  readonly offers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly partner: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"AvatarName_actor">;
        };
      } | null;
    } | null>;
  };
  readonly " $fragmentType": "TeamCard_artist";
};
export type TeamCard_artist$key = {
  readonly " $data"?: TeamCard_artist$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamCard_artist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamCard_artist",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "isAccepted",
          "value": true
        }
      ],
      "concreteType": "OfferNodeConnection",
      "kind": "LinkedField",
      "name": "offers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OfferNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OfferNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PartnerNode",
                  "kind": "LinkedField",
                  "name": "partner",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "AvatarName_actor"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "offers(isAccepted:true)"
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};

(node as any).hash = "32379b0e05555e87f76cd06738d17927";

export default node;
